<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 col-md-12 pl-0 pr-0 pr-md-3 d-flex flex-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mr-3">
                        <div id="filterTutorial" class="cpl-12 pt-3 pb-3">
                            <div class="col-12 pb-3 pl-3 pr-3 pl-md-4 pr-md-4 font-size-10">
                                <div class="col-12 pl-0 pr-0 d-md-flex flex-wrap justify-content-md-between">
                                    <div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 d-flex">
                                        <div class="col-12 col-md-9 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-12 pl-0 pr-0">
                                                <v-select v-model="category.value" :options="tutorialCategoryOptions"
                                                    label="tutorial_category_name" :reduce="el => el.tutorial_category_slug_name"
                                                    class="font-size-9 w-100" placeholder="Pilih Kategori">
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pt-2 pt-md-0 d-flex">
                                        <div class="col-12 pl-0 pr-0 pr-md-3 d-flex">
                                            <div class="col-12 pl-0 pr-0">
                                                <input v-model="title.value"
                                                    class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple"
                                                    type="text" placeholder="Judul Tutorial">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-md-2 pt-lg-3 d-flex flex-wrap justify-content-end">
                                    <div class="col-12 col-md-4 pl-0 pr-0 pl-md-3 pr-md-3 pt-2 pt-md-0 d-flex">
                                        <div class="col-12 pl-0 pr-0 d-flex">
                                            <div class="col-6 pl-0 pr-2">
                                                <button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus">
                                                    <div class="font-size-9" @click="reset">Reset</div>
                                                </button>
                                            </div>
                                            <div class="col-6 pl-2 pr-0">
                                                <button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus">
                                                    <div class="font-size-9" @click="cari">Cari</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex pl-0 flex-column flex-md-row">
                    <div class="col-12  pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 d-flex">
                            <div class="col-8 col-md-6 pl-0 pb-1 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-sm-11">List E-Learning</div>
                            </div>
                        </div>
                        <div class="col-12 mb-2 pl-0 pr-0 d-flex flex-wrap">
                            <div v-show="dataListTutorial.length == 0">
                                <div class="col-2 pt-3 pl-2 pr-2" v-for="(index) in 6" :key="index">
                                    <div class="card">
                                        <vcl :width='300' :height='150'>
                                            <rect x="0" y="0" rx="2" ry="2" width="300" height="150" />
                                        </vcl>
                                        <div class="card-body pl-2">
                                            <vcl :width='300' :height='150'>
                                                <rect x="0" y="0" rx="2" ry="2" width="300" height="30" />
                                                <rect x="0" y="40" rx="2" ry="2" width="150" height="30" />
                                            </vcl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-if="dataListTutorial == 'error'">
                                <div class="col-12 pt-3 pb-3 text-center">
                                    <div class="col-6 col-md-4 ml-auto mr-auto">
                                        <img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
                                    </div>
                                    <div class="font-size-11 pt-1">Data tidak tersedia!</div>
                                </div>
                            </div>
                            <div class="col-12 mb-2 pl-0 pr-0 d-flex flex-wrap" v-else>
                                <div class="col-12 col-md-4 col-lg-3 pt-3 pl-2 pr-2" v-for="(value, index) in dataListTutorial" :key="index">
                                    <div class="card" role="button" @click="goToDetail(value)">
                                        <div class="text-center bg-light">
                                            <img :src="value.tutorial_thumbnail" :alt="value.tutorial_title" class="img-fluid" :style="{ 'max-height': '200px', 'object-fit': 'cover', 'width' : '500px' }">
                                        </div>
                                        <router-link :to="{ name: 'tutorial-detail', params: { id: value.tutorial_id} }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('tutorial-detail'))|| userData.stockist_type== 'utama'">
                                            <div class="card-body pl-2">
                                                <h5 class="card-title color-black mb-0">{{ value.tutorial_title }}</h5>
                                                <span class="badge badge-pill" :style="{ 'background-color': value.tutorial_category_color, 'color': fontColorbyBG(value.tutorial_category_color) ? '#FFFFFF' : '#000000' }">{{ value.tutorial_category_name }}</span>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pl-2 pr-2">
                            <div class="col-12 border-bottom"></div>
                        </div>
                        <div class="col-12 pt-3 pl-2 pr-2 text-center">
                            <i-pagination :limit='limit' @changeLimit="changeLimit($event)" :pagination='pagination' @gotoPage="gotoPage($event)"
                                @refresh="refresh($event)"></i-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    components: {
        IPagination,
    },
    data() {
        return {
            tanggalAwal: "",
            tanggalAkhir: "",
            tfilter: false,
            today: new Date().toISOString(),
            limit: 10,
            category: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'tutorial_category_slug_name'
            },
            title: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'tutorial_title'
            },
            params: {},
            rangeLaporan: '',
            page: 1
        }
    },
    methods: {
        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataTutorial({ page: this.page, limit: this.limit })
            }
        },
        refresh(val) {
            this.page = val
            if (this.params) {
                this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataTutorial({ page: this.page, limit: this.limit })
            }
        },
        changeLimit(val) {
            this.page = 1
            this.limit = val
            if (this.params) {
                this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataTutorial({ page: this.page, limit: this.limit })
            }
        },
        cari() {
            this.params = []
            this.page = 1
            if (this.title.value) {
                this.params.push(this.title)
            }
            if (this.category.value) {
                this.params.push(this.category)
            }
            this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
        },
        reset() {
            this.title.value = ''
            this.category.value = ''
            this.page = 1
            this.params = []
            this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
        },
        toggleFilter() {
            if (!this.tfilter) {
                this.tfilter = true;
            } else {
                this.tfilter = false;
            }
        },
        fontColorbyBG(bgColor) {
            let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
            let r = parseInt(color.substring(0, 2), 16); // hexToR
            let g = parseInt(color.substring(2, 4), 16); // hexToG
            let b = parseInt(color.substring(4, 6), 16); // hexToB
            return ((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186;
        },
        generateEmbed(url) {
            let video_id = url.split('v=')[1]
            let ampersandPosition = video_id.indexOf('&')
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition)
            }
            return "https://www.youtube.com/embed/" + video_id + "?controls=0&fs=0&disablekb=1" + "frameborder='0';"
        },
        ...mapActions('tutorialList', ['getDataTutorial', 'getOptionTutorailCategory']),
    },
    computed: {
        ...mapState('tutorialList', ['dataListTutorial', 'tutorialCategory', 'pagination']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),
        tutorialCategoryOptions() {
            const a = [{ tutorial_category_name: 'Semua Kategori', tutorial_category_slug_name: '' }, ...this.tutorialCategory]
            return a
        },
    },
    created() {
        this.$store.dispatch('setPageTitle', 'List E-Learning');

        this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
        this.getOptionTutorailCategory()
    }
};
</script>
